import dayjs from "dayjs";

import { UplotTooltipProps } from "@/utils/uplot-plugins/tooltip-plugin";

import { ULineChartDataInfo } from "../ULineChartProps";

export const tooltipContent = ({
  dataInfo,
}: {
  dataInfo: ULineChartDataInfo[];
}): UplotTooltipProps => ({
  content: (
    <div className="pointer-events-none rounded-lg bg-white p-4 shadow-md">
      <p className="pb-2 text-xs text-gray-500" id="date" />
      {dataInfo.map((info, i) => (
        <div
          className="flex justify-between gap-8 truncate py-[2px] text-sm"
          key={i}
        >
          <div className="flex items-center gap-2">
            <span className="mt-px h-3 w-3 rounded-full" id={`indicator${i}`} />
            <p className="truncate text-xs" id={`label${i}`} />
          </div>
          <p className="truncate text-xs font-medium" id={`value${i}`} />
        </div>
      ))}
    </div>
  ),
  renderContent: ({ u, dataIndex, container }) => {
    const date = dayjs.unix(u.data[0][dataIndex]).format("YYYY/MM/DD");
    const DateEl = container.querySelector("#date") as HTMLParagraphElement;
    DateEl.textContent = date;

    dataInfo.forEach((info, i) => {
      const yVal = u.data[i + 1][dataIndex];

      const IndicatorEl = container.querySelector(
        `#indicator${i}`
      ) as HTMLSpanElement;

      IndicatorEl.style.backgroundColor = info.strokeColor;

      const LabelEl = container.querySelector(
        `#label${i}`
      ) as HTMLParagraphElement;
      LabelEl.textContent = info.tooltipLabel ?? info.label;

      const ValueEl = container.querySelector(
        `#value${i}`
      ) as HTMLParagraphElement;
      const formatter = info.valueFormatter ?? ((v) => v);
      ValueEl.textContent = formatter(yVal) as string;
    });
  },
});
